<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
    <div class="row">
      <div class="col-12"></div>
      <div class="col-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <!-- ngx-datatable-filter -->
              <fieldset class="form-group">
                <div class="row project-list">
                  <div class="col-12 col-sm-12 col-md-9 col-lg-9 mt-2 mb-1">
                    <div class="row-flex">
                      <div class="col-flex-2 mb-1 position-relative">
                        <input id="ngx-filter-ref" autocomplete="off"
                          class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                          type="text" placeholder="Search" (keydown.enter)="getFilterProject($event.target.value)" #name />
                        <button class="btn search-btn glow position-absolute" (click)="getFilterProject(name.value)">
                          <i class="ft-search text-white cursor-pointer"></i>
                        </button>
                      </div>
                      <div class="col-flex-2 mb-1">
                        <button class="btn btn-primary btn-block users-list-clear glow mb-0" (click)="resetFilter()">
                          Reset
                          <i class="ft-filter text-white cursor-pointer"></i>
                        </button>
                      </div>
                      <!-- <div class="col-flex-2 mb-1"
                        *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                        <button type="button" class="btn btn-primary btn-block users-list-clear glow mb-0"
                          routerLink="/jobs/add" placement="top" ngbTooltip="Add New">
                          +
                        </button>
                      </div> -->
                    </div>
                  </div>
                  <div class="col-12">
                    <button *ngIf="guideline_data[0]" class="btn btn-outline-primary" (click)="createDynamicComponent(guideline_data[0])">Batch Audit Guideline</button>
                    </div>
                </div>
              </fieldset>
              <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
                [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
                [columns]="columns" [externalPaging]="true" [count]="page.totalPages" [offset]="page.pageNumber"
                (page)="pageChangeData($event)">
                <ngx-datatable-column name="Batch Name" prop="name" [width]="350">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div class="d-flex align-items-center">
                      <img class="rounded-circle mr-1" *ngIf="row.image" [src]="imageUrl + row.image" height="32"
                        width="32" />
                      <div class="cell-line-height cursor-pointer" [routerLink]="['/project/project-view', row._id]"
                        (click)="editProject(row._id)">
                        <p class="font-medium-1 line-height-1 mb-0" [ngClass]="{'bg-light-danger': row?.on_aleart == 'yes'}">
                          {{ row.name }}
                        </p> 
                      </div>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Productivity" [width]="170">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <span>
                     
                      <span placement="right" ngbTooltip="Activity">
                        <div class="avatar mr-1 ml-0 badge badge-pill bg-light-success" [ngClass]="{'bg-light-danger':row?.activity?.is_alert =='yes',
                        'avatar-border':row?.activity?.description !==''|| row?.activity?.last_aditdate !==''}" 
                        (click)="openModal(myModal,row,'Activity','activity',row?.activity.description,row?.activity?.is_alert,row?.activity?.last_aditdate)">
                          <div class="avatar-content">A</div> 
                        </div>
                      </span>
                      <span placement="right" ngbTooltip="Certification">
                        <div class="avatar mr-1 ml-0 badge badge-pill bg-light-success" [ngClass]="{'bg-light-danger':row?.certification?.is_alert =='yes',
                        'avatar-border':row?.certification?.description !==''|| row?.certification?.last_aditdate !==''}" 
                        (click)="openModal(myModal,row,'Certification','certification',row?.certification.description,row?.certification?.is_alert,row?.certification?.last_aditdate)">
                          <div class="avatar-content">C</div>
                        </div>
                      </span>
                      <span placement="right" ngbTooltip="Placement">
                        <div class="avatar mr-1 ml-0 badge badge-pill bg-light-success" [ngClass]="{'bg-light-danger':row?.placement?.is_alert =='yes',
                        'avatar-border':row?.placement?.description !==''|| row?.placement?.last_aditdate !==''}" 
                        (click)="openModal(myModal,row,'Placement','placement',row?.placement.description,row?.placement?.is_alert,row?.placement?.last_aditdate)">
                          <div class="avatar-content">P</div>
                        </div>
                      </span>
                      <span placement="right" ngbTooltip="Student Overview">
                        <div class="avatar mr-1 ml-0 badge badge-pill bg-light-success" [ngClass]="{'bg-light-danger':row?.student_overview?.is_alert =='yes',
                        'avatar-border':row?.student_overview?.description !==''|| row?.student_overview?.last_aditdate !==''}" 
                        (click)="openModal(myModal,row,'Student Overview','student_overview',row?.student_overview.description,row?.student_overview?.is_alert,row?.student_overview?.last_aditdate)">
                          <div class="avatar-content">S</div>
                        </div>
                      </span>
                      <span placement="right" ngbTooltip="Tesimonial">
                        <div class="avatar mr-1 ml-0 badge badge-pill bg-light-success" [ngClass]="{'bg-light-danger':row?.tesimonial?.is_alert =='yes',
                        'avatar-border':row?.tesimonial?.description !==''|| row?.tesimonial?.last_aditdate !==''}" 
                        (click)="openModal(myModal,row,'Tesimonial','tesimonial',row?.tesimonial.description,row?.tesimonial?.is_alert,row?.tesimonial?.last_aditdate)">
                          <div class="avatar-content">T</div>
                        </div>
                      </span>
                      <span placement="right" ngbTooltip="Rating">
                        <div class="avatar mr-1 ml-0 badge badge-pill bg-light-success" [ngClass]="{'bg-light-danger':row?.rating?.is_alert =='yes',
                        'avatar-border':row?.rating?.description !==''|| row?.rating?.last_aditdate !==''}" 
                        (click)="openModal(myModal,row,'Rating','rating',row?.rating.description,row?.rating?.is_alert,row?.rating?.last_aditdate)">
                          <div class="avatar-content">R</div>
                        </div>
                      </span>
                    </span>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Actions" [width]="80"
                  *ngIf="user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                  <ng-template let-row="row" ngx-datatable-cell-template> 
                    <i *ngIf="!row?.activity.description || !row?.placement.description|| !row?.certification.description || !row?.rating.description" class="ft-edit text-primary cursor-pointer mr-2" [routerLink]="['/batches/edit-batch-audit', row._id]"
                      ></i>
                      
                    <!-- <i class="ft-trash-2 cursor-pointer danger" (click)="ConfirmColor(row._id)"></i> -->
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
              <!-- ngx-datatable-filter -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--/ Filter Datatables -->
  
  <!----- Update Row Popup ----------->
  <div>
      <ng-template #myModal let-modal>
          <div class="modal-header">
              <h4 class="modal-title">{{batch_data.name}}<span>'s</span> Update</h4>
              <button type="button" class="close" (click)="modal.dismiss()">
                  <span>&times;</span>
              </button>
          </div>
          <div class="modal-body">
              <form>
                <div class="form-group">
                    <label>is_alert</label>
                    <ng-select
                    [items]="alert_list"
                    bindLabel="name"
                    color="is_activated"
                    bindValue="id"
                    placeholder="Select Alert"
                    [(ngModel)]="alert_event"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="selectAlert($event)" 
                    >
                    </ng-select>
                </div>
                <div class="form-group">
                    <label>Last Audit</label>
                    <input type="text" class="form-control" [(ngModel)]="lastAudit" [ngModelOptions]="{standalone: true}" >
                </div>
                <div class="form-group">
                    <label>{{row_name}} Description</label>
                    <textarea name="description" id="description" cols="30" rows="1"  class="form-control" [(ngModel)]="row_value" [ngModelOptions]="{standalone: true}"></textarea>
                </div>
              </form>
              
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
              <button type="button" class="btn btn-primary" (click)="updateRow()">Submit</button>
            </div>
      </ng-template>
  </div>
  <div class="d-flex justify-content-between align-items-center">
    <ngx-spinner></ngx-spinner>
  </div>

  <div #dynamicContainer></div>